import { useState, useEffect, useRef, useCallback } from "react";
import { useAudioPlayerContext } from "../../../context/audioPlayerContext";
import { Pause, Play } from "lucide-react";

export const Control = () => {
  const {
    currentAudio,
    audioRef,
    setDuration,
    progressBarRef,
    duration,
    setTimeProgress,
  } = useAudioPlayerContext();
  const [isPlaying, setIsPlaying] = useState(false);
  const playAnimationRef = useRef(null);

  const updateProgress = useCallback(() => {
    if (audioRef.current && progressBarRef.current && duration) {
      const currentTime = audioRef.current.currentTime;
      setTimeProgress(currentTime);
      progressBarRef.current.value = currentTime.toString();
      progressBarRef.current.style.setProperty(
        "--range-progress",
        `${(currentTime / duration) * 100}%`,
      );
    }
  }, [duration, setTimeProgress, audioRef, progressBarRef]);

  const startAnimation = useCallback(() => {
    if (audioRef.current && progressBarRef.current && duration) {
      const animate = () => {
        updateProgress();
        playAnimationRef.current = requestAnimationFrame(animate);
      };
      playAnimationRef.current = requestAnimationFrame(animate);
    }
  }, [updateProgress, duration, audioRef, progressBarRef]);

  useEffect(() => {
    if (isPlaying) {
      audioRef.current?.play();
      startAnimation();
    } else {
      audioRef.current?.pause();
      if (playAnimationRef.current !== null) {
        cancelAnimationFrame(playAnimationRef.current);
        playAnimationRef.current = null;
      }
      updateProgress();
    }
    return () => {
      if (playAnimationRef.current !== null) {
        cancelAnimationFrame(playAnimationRef.current);
      }
    };
  }, [isPlaying, startAnimation, updateProgress, audioRef]);

  const onLoadedMetadata = () => {
    const seconds = audioRef.current?.duration;
    if (seconds !== undefined) {
      setDuration(seconds);
      if (progressBarRef.current) {
        progressBarRef.current.max = seconds.toString();
      }
    }
  };
  return (
    <>
      <audio
        src={currentAudio}
        ref={audioRef}
        onLoadedMetadata={onLoadedMetadata}
      />
      <button onClick={() => setIsPlaying((prev) => !prev)}>
        {!isPlaying ? (
          <Play
            className="bg-primary rounded-full size-10 p-2"
            fill="white"
            stroke="white"
          />
        ) : (
          <Pause
            className="bg-primary rounded-full size-10 p-2"
            fill="white"
            stroke="white"
          />
        )}
      </button>
    </>
  );
};
